<template>
<q-drawer
    v-model="leftDrawerOpen"
    class="sidebar sidebar-left"
    side="left"
    bordered
    :mini="!leftDrawerOpen || miniState"
    :mini-width="64"
    :width="350"
    :breakpoint="600"
    show-if-above
>
  <div class="column full-height">
    <div class="col-shrink sidebar__header">
      <div class="row items-start"
           :class="{'justify-between q-ma-md': !miniState, 'justify-center q-my-md': miniState}">
        <common-input
            v-model="search"
            class="form__input search q-mini-drawer-hide"
            label="Zoekterm"
            @keydown.enter="doSearch"
            @clear="doSearch"
            @blur="doSearch"
            dense
            clearable>
          <icon-button
              v-slot:append
              icon="search"
              flat
              round
              dense
              @click="doSearch"
              :color="search ? 'info' : ''"
              aria-label="Zoek" />

        </common-input>
        <icon-button
            :id="miniState ? 'sidebar-close' : 'sidebar-open'"
            :class="{'rotate-180': !miniState}"
            icon="double_arrow"
            :aria-label="miniState ? 'Open linker sidebar' : 'Sluit linker sidebar'"
            @click="miniState = !miniState"
        />
      </div>
    </div>
    <component v-if="innerComponent"
               :is="innerComponent"
               ref="innerComponent"
               v-bind="pageData" />
  </div>
</q-drawer>
</template>

<script>
import ProjectIndex from '~HIOR/components/sidebars/ProjectIndex'
import ProjectRuleIndex from '~HIOR/components/sidebars/ProjectRuleIndex'
import CategoryIndex from '~HIOR/components/sidebars/CategoryIndex'
import GuidelineMenu from '~HIOR/components/menu/GuidelineMenu'
import MapGroupIndex from '~HIOR/components/sidebars/MapGroupIndex'
import ObjectIndex from '~HIOR/components/sidebars/ObjectIndex'
import ObjectGroupIndex from '~HIOR/components/sidebars/ObjectGroupIndex'
import PhaseIndex from '~HIOR/components/sidebars/PhaseIndex'
import RoleIndex from '~HIOR/components/sidebars/RoleIndex'
import RuleIndex from '~HIOR/components/sidebars/RuleIndex'
import SubcategoryIndex from '~HIOR/components/sidebars/SubcategoryIndex'
import ThemeIndex from '~HIOR/components/sidebars/ThemeIndex'
import UserIndex from '~HIOR/components/sidebars/UserIndex'
import ProjectObjectIndex from '~HIOR/components/sidebars/ProjectObjectIndex'
import ImportSourceIndex from '~HIOR/components/sidebars/ImportSourceIndex'
import IconButton from '../button/IconButton'

export default {
  components: {
    IconButton,
    CategoryIndex,
    GuidelineMenu,
    MapGroupIndex,
    ObjectIndex,
    ObjectGroupIndex,
    PhaseIndex,
    ProjectIndex,
    ProjectRuleIndex,
    RoleIndex,
    RuleIndex,
    SubcategoryIndex,
    ThemeIndex,
    UserIndex,
    ProjectObjectIndex,
    ImportSourceIndex,
  },
  props: {
    innerComponent: {
      type: String,
    },
    pageData: {
      type: Object,
      default: () => ({}),
    },
    breakPoint: {
      type: Number,
      default: 1100,
    },
  },
  data () {
    let params = new URLSearchParams(location.search)
    return {
      leftDrawerOpen: true,
      miniState: false,
      search: params.get('search') || this.pageData?.filters?.search,
      page: 'project',
    }
  },
  methods: {
    checkSize () {
      this.miniState = document.body.clientWidth < this.breakPoint
    },
    doSearch () {
      if (this.$refs.innerComponent.doSearch) {
        return this.$refs.innerComponent.doSearch(this.search)
      }
      this.$goto(this.$route().current(), {
        ...this.$route().params,
        search: this.search,
      })
    },
  },
  mounted () {
    this.checkSize()
    window.addEventListener('resize', this.checkSize)
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.checkSize)
  },
}
</script>
